import axios from 'axios';
import store from '@/store';

class EstoqueServices {
    constructor() {
        this.api = axios.create({
            baseURL: process.env.VUE_APP_ENV === 'development'
                ? process.env.VUE_APP_API_CONSULTA_ESTOQUE_URL
                : `${location.protocol}//${location.host}${process.env.VUE_APP_API_CONSULTA_ESTOQUE_URL}`,
            timeout: +process.env.VUE_APP_REQUEST_TIMEOUT * 1000,
        });

        this.api.interceptors.request.use((config) => {
            const token = localStorage.getItem('jwtToken');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        }, (error) => {
            return Promise.reject(error);
        });

        this.api.interceptors.response.use(
            (response) => response.data,
            (error) => {
                return Promise.reject(error);
            }
        );
    }

    buscarEstoque(params) {
        const cod_rede = store.getters.getCodigoRede;
        if (!cod_rede) {
            return Promise.reject("Erro! Cod_rede faltando");
        }
        return this.api.get('/estoques', { params: { ...params, cod_rede: cod_rede } });
    }
}

export default new EstoqueServices();
